module.exports = __webpack_public_path__ + "static/icon_item4.8d6a71ab.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_item4.png
// module id = 1044
// module chunks = 2